import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'partnerSatClients',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPartnerSatClients: builder.query({
      query: (params) => {
        return ({
          url: '/sat_clients',
          params: {
            page: params.page,
            ...params.filters,
          },
        })
      },
      providesTags: (result) => [{ type: 'partnerSatClients', id: 'LIST' }],
    }),
  }),

  overrideExisting: false,
})


export const {
  useFetchPartnerSatClientsQuery,
} = extendedApi
